import React from 'react';
import Spinner from '../../../uikit/misc/Spinner';
import Box from '@mui/material/Box';
export function SimpleSkeleton(props) {
    if (props.isLoading) {
        return (React.createElement(Box, { p: 4, style: { textAlign: 'center' } },
            React.createElement(Spinner, null),
            React.createElement("div", { style: {
                    overflow: 'hidden',
                    width: 1,
                    height: 1,
                    visibility: 'hidden',
                } }, props.children)));
    }
    return React.createElement(React.Fragment, null, props.children);
}
